import { render } from "./hero_section.html?vue&type=template&id=4a125cec&external"
import script from "./hero_section.js?vue&type=script&lang=js&external"
export * from "./hero_section.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__